export default (icon: string, color: any) => {
  return {
    suggestions: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.89 21.7" width="48px" height="55px">
        <defs>
            <clipPath id="clip-path">
                <rect style="fill:none" x="0.05" y="0.06" width="19.33" height="21.42"/>
            </clipPath>
        </defs>
        <title>Asset 5</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <g style="clip-path:url(#clip-path);">
                    <path style="fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;stroke-width:0.5px;" d="M9.2,5.32A3.26,3.26,0,0,0,5.94,8.59M6.81,18H11.6M6.81,16.21H11.6"/>
                </g>
                <path style="fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;"
                      d="M9.45,1.81V.5M2.85,5.34l-1.2-.67m15.59,8.77L16,12.76M5.64,2.63l-.7-1.17m4.51.35V.5m3.8,2.13L14,1.46M16,5.34l1.2-.67M1.65,13.44l1.2-.68m14.2-3.55h1.34M.5,9.21H1.84"/>
                <path style="fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;"
                      d="M15,8.8A5.46,5.46,0,0,0,9.5,3.42,5.46,5.46,0,0,0,4,8.8a5.36,5.36,0,0,0,2.85,4.71V21.2h5.36V13.51A5.36,5.36,0,0,0,15,8.8Z"/>
            </g>
        </g>
      </svg>
    `,
    comments: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.44 21.29" width="57px" height="52px">
        <defs>
            <clipPath id="clip-path">
                <rect style="fill:none;" x="0.06" y="0.06" width="23.28" height="20.89"/>
            </clipPath>
        </defs>
        <title>Asset 2</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <g style="clip-path:url(#clip-path);">
                    <polygon style="fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;"
                            points="0.5 4.88 0.5 17.08 3.12 17.08 3.11 20.79 7.14 17.08 15.31 17.08 15.31 4.88 0.5 4.88"/>
                </g>
                <polygon style="clip-path:url(#clip-path);fill:#ededed;"
                        points="22.94 0.5 22.94 12.7 20.32 12.7 20.32 16.4 16.29 12.7 8.13 12.7 8.13 0.5 22.94 0.5"/>
                <g style="fill:#ededed;">
                    <polygon style="fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;"
                            points="22.94 0.5 22.94 12.7 20.32 12.7 20.32 16.4 16.29 12.7 8.13 12.7 8.13 0.5 22.94 0.5"/>
                </g>
                <path style="fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;stroke-width:0.5px;" d="M11,8.51h9.15M11,6.83h9.15M11,5.15h9.15"/>
            </g>
        </g>
      </svg>
    `,
    participents: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.96 20.98" width="78px" height="53px">
        <defs>
            <clipPath id="clip-path">
                <rect style="fill:none;" x="0.06" y="0.06" width="30.67" height="20.66"/>
            </clipPath>
            <clipPath id="clip-path-2">
                <rect style="fill:none;" x="0.06" y="0.06" width="31.22" height="20.66"/>
            </clipPath>
        </defs>
        <title>Asset 3</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <g style="stroke-linecap:round;stroke-linejoin:round;">
                    <path style="fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;"
                          d="M18.75,3.5a1.67,1.67,0,0,1,.58-1.26L20.81.9A1.67,1.67,0,0,1,21.9.5h1.91A1.62,1.62,0,0,1,24.9.91l1.53,1.33A1.69,1.69,0,0,1,27,3.5V7.18L25.24,9.05v1.66l4.11,2a1.67,1.67,0,0,1,1.11,1.57V19M12.21,3.5a1.67,1.67,0,0,0-.58-1.26L10.14.9A1.64,1.64,0,0,0,9.06.5H7.14A1.64,1.64,0,0,0,6.05.91L4.53,2.24A1.69,1.69,0,0,0,4,3.5V7.18L5.72,9.05v1.66l-4.11,2A1.66,1.66,0,0,0,.5,14.25V19m22.17,1.52V16.23a1.65,1.65,0,0,0-1.1-1.56l-3.83-2V11l1.73-1.87V5.49a1.65,1.65,0,0,0-.58-1.26L17.4,2.89a1.64,1.64,0,0,0-1.08-.4H14.4a1.69,1.69,0,0,0-1.09.4L11.79,4.23a1.66,1.66,0,0,0-.57,1.26V9.17L13,11V12.7l-4.11,2a1.65,1.65,0,0,0-1.11,1.57v4.24"/>
                </g>
                <g style="clip-path:url(#clip-path-2);">
                    <path style="fill:none;stroke:${color};stroke-miterlimit:10;stroke-width:0.5px;" d="M11.87,13.07a4.5,4.5,0,0,0,7.24.33"/>
                </g>
            </g>
        </g>
      </svg>
    `,
    version: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.25 21.48" width="40px" height="53px">
        <defs>
            <clipPath id="clip-path">
                <rect style="fill:none;" x="0.06" y="0.06" width="16.08" height="21.31"/>
            </clipPath>
        </defs>
        <title>Asset 4</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path style="fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;stroke-width:0.5px;"
                      d="M12.7,15.53H3.55m9.15-1.68H3.55m9.15-1.68H3.55m9.15-1.68H3.55M12.7,8.8H3.55M12.7,4.88h-3"/>
                <g style="clip-path:url(#clip-path);">
                    <path style="fill:none;stroke:${color};stroke-linecap:round;stroke-linejoin:round;" d="M4.86,1V5.1H.5M15.75.5V21H.5v-16L5,.5Z"/>
                </g>
            </g>
        </g>
      </svg>
    `
  }[icon]
}